var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(!_vm.isFull)?[_c('Header')]:_vm._e(),_c('main',[_c('router-view')],1),(!_vm.isFull)?[_c('FooterWorkflowTool'),_c('Footer')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }